import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-modal-selecionar-operadora',
  templateUrl: './modal-selecionar-operadora.component.html',
  styleUrls: ['./modal-selecionar-operadora.component.scss'],
})
export class ModalSelecionarOperadoraComponent implements OnInit {
  @Output() fecharModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() operadoraSelecionada: EventEmitter<number> = new EventEmitter<number>();
  public bilhetadoraId: number;
  public operadoraId: number;

  constructor() {}

  ngOnInit() {}

  public setOperadoraId(event: number) {
    this.operadoraId = event;
  }

  public setBilhetadoraId(event: number) {
    this.bilhetadoraId = event;
  }

  public closeModal() {
    this.fecharModal.emit(true);
  }

  public setarOperadora() {
    this.operadoraSelecionada.emit(this.operadoraId);
  }

  public get desabilitarBotao(): boolean {
    let retorno = false;
    if (!this.operadoraId) {
      retorno = true;
    }
    return retorno;
  }
}
